export const numberToFrenchText = (num: number): string => {
    if (!num) return "zéro";
  
    const units = [
      "",
      "un",
      "deux",
      "trois",
      "quatre",
      "cinq",
      "six",
      "sept",
      "huit",
      "neuf",
    ];
    const teens = [
      "dix",
      "onze",
      "douze",
      "treize",
      "quatorze",
      "quinze",
      "seize",
      "dix-sept",
      "dix-huit",
      "dix-neuf",
    ];
    const tens = [
      "",
      "dix",
      "vingt",
      "trente",
      "quarante",
      "cinquante",
      "soixante",
      "soixante-dix",
      "quatre-vingts",
      "quatre-vingt-dix",
    ];
  
    const convertChunk = (chunk: number): string => {
      if (chunk === 0) return "";
  
      let text = "";
      const hundred = Math.floor(chunk / 100);
      const remainder = chunk % 100;
  
      if (hundred > 0) {
        text += `${units[hundred]} cent`;
        if (remainder === 0 && hundred > 1) text += "s"; // "cents" for plural
        if (remainder !== 0) text += " ";
      }
  
      if (remainder < 10) {
        text += units[remainder];
      } else if (remainder < 20) {
        text += teens[remainder - 10];
      } else {
        const ten = Math.floor(remainder / 10);
        const unit = remainder % 10;
  
        if (ten === 7 || ten === 9) {
          // Special cases for 70 (soixante-dix) and 90 (quatre-vingt-dix)
          text += `${tens[ten - 1]}-${teens[unit]}`;
        } else {
          text += tens[ten];
          if (unit === 1 && ten !== 8 && ten !== 9) text += " et"; // "et un" for 21, 31, etc.
          if (unit > 1) text += `-${units[unit]}`;
        }
      }
  
      return text.trim();
    };
  
    const convertLargeNumber = (Numero: number, divisor: number, unitName: string): string => {
      const chunk = Math.floor(Numero / divisor);
      const remainder = Numero % divisor;
  
      let result = "";
  
      if (chunk > 0) {
        result += `${convertChunk(chunk)} ${unitName}`;
        if (chunk > 1 && unitName !== "mille") result += "s"; // Plural for millions, billions, etc.
        if (remainder !== 0) result += " ";
      }
  
      return result;
    };
  
    let result = "";
  
    // Trillions
    result += convertLargeNumber(num, 1_000_000_000_000, "trillion");
    num %= 1_000_000_000_000;
  
    // Billions
    result += convertLargeNumber(num, 1_000_000_000, "milliard");
    num %= 1_000_000_000;
  
    // Millions
    result += convertLargeNumber(num, 1_000_000, "million");
    num %= 1_000_000;
  
    // Thousands
    result += convertLargeNumber(num, 1000, "mille");
    num %= 1000;
  
    // Hundreds, Tens, and Units
    result += convertChunk(num);
  
    return result.trim();
};